import React from "react";

import {User} from "@phosphor-icons/react";

export default function Avatar(props) {
  if (props.img) {
    return (
      <div className={`avatar ${props.size ? "avatar-" + props.size : ""} ${props.shape ? "avatar-" + props.shape : ""} ${props.status ?  props.status : ""}`}>
        <User size={48} />
      </div>
    );

  } else if (props.initial) {
    return (
      <div className={`avatar ${props.size ? "avatar-" + props.size : ""} ${props.shape ? "avatar-" + props.shape : ""} ${props.status ? props.status : ""}`}>
        <span className="avatar-initial"><User size={16} weight="bold" /></span>
      </div>
    );
  }
}